import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { borderRadius } from "../../../design-system/tokens/borders";

/**
 * Natural slide dimensions (PPT 16:9 default).
 * Change SLIDE_NATURAL_WIDTH_PX here → all dependents (SlideThumbnail scale,
 * export constants) update automatically. No other number to touch.
 */
export const SLIDE_NATURAL_WIDTH_PX = 1280;
export const SLIDE_ASPECT_RATIO = 16 / 9;
export const SLIDE_NATURAL_HEIGHT_PX = Math.round(
  SLIDE_NATURAL_WIDTH_PX / SLIDE_ASPECT_RATIO,
); // 720

/**
 * Floating slide shadow from the design (F16). GAP: no shadow token has this
 * 0 20px 40px -8px violet-ink shadow; kept here so the Slide and the deck's
 * snapshot image share one value.
 */
export const SLIDE_FRAME_SHADOW = "0 20px 40px -8px rgba(24, 16, 43, 0.18)";

/**
 * Full-size slide frame (Figma 3730:514832).
 * Responsive: fills parent width, height auto-tracked at 16:9 via CSS
 * aspect-ratio. Children are the slide content.
 *
 * Style-map gap: Figma gap=10px has no exact token (spacing[2]=8px,
 * spacing[3]=12px). Using spacing[2] (8px) as nearest; flag for design review.
 */
export const SlideFrame = styled.div`
  box-sizing: border-box;
  width: 100%;
  aspect-ratio: ${SLIDE_ASPECT_RATIO};
  /* Must stay visible: with overflow hidden, an aspect-ratio box ignores its
     content's minimum height and CLIPS widgets taller than 16:9. Visible lets
     the frame grow with content — the ratio is the preferred shape, not a crop. */
  overflow: visible;
  display: flex;
  flex-direction: column;
  gap: ${spacing[2.5]};
  padding: ${spacing[3]};
  background: ${rawColors.structural.white};
  border-radius: ${borderRadius["2xl"]};
  box-shadow: ${SLIDE_FRAME_SHADOW};
`;
